import { Container } from '@mui/material';
import { PUBLIC_CONTENT_MAX_WIDTH } from '../Data/layout';

export const publicPalette = {
  background: '#050914',
  surface: '#0B1222',
  surfaceRaised: '#101A30',
  border: 'rgba(148, 163, 184, 0.18)',
  primary: '#38BDF8',
  secondary: '#8B5CF6',
  accent: '#22D3A7',
  text: '#F8FAFC',
  muted: '#A7B3C7',
};

export const appChromePalette = {
  header: 'linear-gradient(110deg, #0B1222 0%, #101A30 58%, #151D38 100%)',
  drawer: '#080F1E',
  border: 'rgba(148, 163, 184, 0.16)',
  text: '#F8FAFC',
  muted: '#A7B3C7',
  hover: 'rgba(148, 163, 184, 0.08)',
  selected: 'linear-gradient(90deg, rgba(56, 189, 248, 0.18), rgba(139, 92, 246, 0.10))',
  accent: '#38BDF8',
};

export const PublicContainer = ({ children, sx, ...props }) => (
  <Container
    maxWidth={false}
    {...props}
    sx={{
      width: '100%',
      maxWidth: PUBLIC_CONTENT_MAX_WIDTH,
      px: { xs: 2.5, sm: 4, md: 6 },
      ...sx,
    }}
  >
    {children}
  </Container>
);
